module.exports = __webpack_public_path__ + "img/20191226153637360截图20191226102256303.bbb2f6af.jpg";